import { Injectable } from '@angular/core';
import { IdentityWebApiClient, IPartnership, ListPartnershipsRequest, ListPartnershipsResponse, Partnership } from 'identity-webapi-client';
import { ICache } from './theme.service';

@Injectable({
  providedIn: 'root'
})
export class PartnershipService {
  private readonly fiveMinuteCacheDuration = 5 * 60 * 1000; // 5 minutes in milliseconds
  private readonly thirtyMinuteCacheDuration = 30 * 60 * 1000; // 30 minutes in milliseconds

  constructor(
    private identityApiClient: IdentityWebApiClient
  ) {}

  private partnershipsCache: ICache<Partnership> | undefined;
  private loadingPartnershipsPromise: Promise<Partnership[]> | null = null;

  ListPartnerships(request: ListPartnershipsRequest, refreshData: boolean = false): Promise<ListPartnershipsResponse> {
    return this.identityApiClient.listPartnerships(request);
  }
 
  // ListPartnerships(request: ListPartnershipsRequest, refreshData: boolean = false): Promise<Partnership[]> {
  //   if (
  //     this.partnershipsCache &&
  //     this.partnershipsCache.companyId === request.companyId &&
  //     !refreshData &&
  //     (Date.now() - this.partnershipsCache.timestamp) < this.fiveMinuteCacheDuration
  //   ) {
  //     return Promise.resolve(this.partnershipsCache.data);
  //   } 

  //   if (this.loadingPartnershipsPromise && request.companyId === this.partnershipsCache?.companyId) {
  //     return this.loadingPartnershipsPromise;
  //   }

  //   this.loadingPartnershipsPromise = this.identityApiClient.listPartnerships(request)
  //     .then((response: ListPartnershipsResponse) => {
  //       if (response.success && response.partnerships) {
  //         this.partnershipsCache = {
  //           companyId: request.companyId,
  //           timestamp: Date.now(),
  //           data: response.partnerships
  //         };
  //         return response.partnerships;
  //       } else {
  //         throw new Error("Failed to retrieve partnerships.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       throw error; // Rethrow error to be handled by the caller
  //     })
  //     .finally(() => {
  //       this.loadingPartnershipsPromise = null;
  //     });

  //   return this.loadingPartnershipsPromise;
  // }

  getOtherCompanyName(partnership: IPartnership | null, companyId: string): string | undefined {
    if (!partnership || !companyId) return "";
    if (partnership.requesterCompanyId !== companyId) {
      return partnership.requesterCompany?.name;
    }
    return partnership.requesteeCompany?.name; 
  }

  getOtherCompanyId(partnership: IPartnership | null, companyId: string): string | undefined {
    if (!partnership || !companyId) return "";
    if (partnership.requesterCompanyId !== companyId) {
      return partnership.requesterCompany?.id;
    }
    return partnership.requesteeCompany?.id; 
  }

  // GetRange(request: GetRangeRequest): Promise<GetRangeResponse> {
  //   return this.situViewClient.getRange(request);
  // }

  // CreateRange(request: CreateRangeRequest): Promise<CreateRangeResponse> {
  //   return this.situViewClient.createRange(request)
  //     .then((response: CreateRangeResponse) => {
  //       if (response.success) {
  //         this.refreshCacheKey();
  //       }
  //       return response;
  //     });
  // }

  // UpdateRange(request: UpdateRangeRequest): Promise<UpdateRangeResponse> {
  //   return this.situViewClient.updateRange(request)
  //   .then((response: UpdateRangeResponse) => {
  //     if (response.success) {
  //       this.refreshCacheKey();
  //     }
  //     return response;
  //   });
  // }

  // UpdateProductRange(request: UpdateProductRangeRequest): Promise<UpdateProductRangeResponse> {
  //   return this.situViewClient.updateProductRange(request)
  //   .then((response: UpdateProductRangeResponse) => {
  //     if (response.success) {
  //       this.refreshCacheKey();
  //     }
  //     return response;
  //   });
  // }
}